import { Box, Button } from '@mui/material';
import Preloader from 'components/Preloader';
import { useTranslation } from 'react-i18next';
import EmptyMenu from 'components/MenuNew/EmptyMenu';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { usePosTable } from 'pages/PosSettings/hooks/usePosTable';
import { MODE, MUI_TO_SX_STYLES } from 'pages/TableOrdering/config';
import CreateOrEditForm from 'pages/PosSettings/Table/CreateOrEditForm';
import ConfirmPromptModal from 'components/ConfirmPromptModal/ConfirmPromptModal';

// NOTE: The following components are imported from 'TableOrdering',
import TableOrderModal from 'pages/TableOrdering/Tables/TableOrderModal';
import { HeaderContainer, StripedDataGrid } from 'pages/TableOrdering/styles';

const Tables = () => {
  const { t } = useTranslation();

  const {
    handleSubmit,
    handleCancel,
    formMethods,
    tableColumns,
    tableFilter,
    loading,
    open,
    setOpen,
    mode,
    rowsPerPage,
    setRowsPerPage,
    lastCreatedTable,
    selectedSection,
  } = usePosTable();

  return (
    <Box>
      <ConfirmPromptModal
        handleConfirm={formMethods.handleSubmit(handleSubmit)}
        submitData={formMethods.getValues()}
        hasUnsavedChanges={formMethods.formState.isDirty}
        formState={formMethods}
      />

      <HeaderContainer>
        <Button
          id="tablesAddTable"
          onClick={() => setOpen(true)}
          variant="contained"
          color="primary"
          type="button"
          disabled={open}
          className={`${open ? 'disabledButton' : ''}`}
          startIcon={<AddOutlinedIcon />}
        >
          {t('table_ordering.add_table')}
        </Button>
      </HeaderContainer>
      <TableOrderModal
        open={open}
        handleClose={handleCancel}
        title={
          mode === MODE.CREATE
            ? t('table_ordering.add_table')
            : t('table_ordering.edit_table')
        }
        disabled={
          !formMethods.formState.isDirty || !formMethods.formState.isValid
        }
        saveTitle={
          mode === MODE.CREATE
            ? t('table_ordering.add_table')
            : t('table_ordering.save')
        }
        cancelTitle={'Cancel'}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        loading={loading}
      >
        <CreateOrEditForm
          selectedSection={
            mode === MODE.EDIT
              ? selectedSection
              : formMethods.getValues('sectionUuid')
          }
        />
      </TableOrderModal>
      <StripedDataGrid
        sx={MUI_TO_SX_STYLES}
        autoHeight={true}
        hideFooterSelectedRowCount={true}
        getRowClassName={(params) =>
          params?.row?.tableUuid === lastCreatedTable
            ? 'highlight_last-selected_item'
            : ''
        }
        hideFooter={true}
        isEditable={false}
        rowsPerPageOptions={[100]}
        pageSizeOptions={[100]}
        pageSize={rowsPerPage}
        onPageSizeChange={(newPageSize) => setRowsPerPage(newPageSize)}
        rows={tableFilter}
        columns={tableColumns}
        components={{
          LoadingOverlay: Preloader,
          NoRowsOverlay: () => (
            <Box sx={{ mt: '100px' }}>
              <EmptyMenu text={t('There are no tables yet')} />
            </Box>
          ),
        }}
        loading={loading}
      />
    </Box>
  );
};

export default Tables;
